import React from 'react';
import { DisputeReviewFragmentType } from '@pay-bill/graphql';
import { SimpleDiffLine } from './simple-diff-line';

export const DisputeDiffLine = ({
  current,
  dispute,
  showEstimationSymbol,
}: {
  current?: boolean;
  dispute: DisputeReviewFragmentType;
  showEstimationSymbol?: boolean;
}) => (
  <SimpleDiffLine
    current={current}
    payCode={dispute.newPayCode}
    hours={dispute.newTotalSeconds}
    billingRate={dispute.finalRateCents / 100}
    hasCustomRate={dispute.hasCustomRate}
    billingAmount={dispute.billingAmountCents / 100}
    showEstimationSymbol={showEstimationSymbol}
  />
);
